import React from 'react';
import { useIntl } from 'umi';
import { Bubble, Button } from 'tea-component';
import UnloadModal from '@/pages/home/pages/home/Explore/components/UnloadModal';
import AgentCopilotOption from './components/AgentCopilotOption';
import type { IAgentTipBubbleViewProps } from './types';
import './index.scss';

/**
 * Layer 1：AgentTipBubble 纯展示层
 * 职责：渲染 Bubble 提示气泡 + 反馈弹窗
 * 禁止：直接调用 API、dispatch DVA action、使用命令式副作用 API
 */
const AgentTipBubbleView: React.FC<IAgentTipBubbleViewProps> = (props) => {
  const {
    children,
    feedbackVisible,
    onFullscreenMode,
    onCopilotMode,
    onGoToGPT,
    onOpenFeedback,
    onCloseFeedback,
  } = props;

  const { formatMessage } = useIntl();

  const content = (
    <div className="dba-agent-tip-bubble__panel">
      <div className="dbh-agent-logo-menu">
        <div
          className="dbh-agent-logo-menu-item"
          onClick={onFullscreenMode}
        >
          <span
            className="dbh-agent-logo-menu-entry-icon dbh-agent-logo-menu-entry-icon--fullscreen-mode"
            aria-hidden
          />
          <span className="dbh-agent-logo-menu-item-label">
            {formatMessage({ id: 'dbh_agent_entry_fullscreen_mode' })}
          </span>
        </div>
        <AgentCopilotOption onCopilotMode={onCopilotMode} />
      </div>
      <div className="dba-agent-tip-bubble__content">
        <div>
          <div>
            {formatMessage({ id: 'dbh_nav_agent_tip_title' })}
          </div>
          <div>
            {formatMessage({ id: 'dbh_nav_agent_tip_desc' })}
          </div>
        </div>
        <Button type="link" onClick={onGoToGPT} className="dba-agent-tip-bubble__link" style={{ textDecoration: 'none' }}>
          {formatMessage({ id: 'dbh_nav_agent_tip_go_to_gpt' })}
        </Button>
        <Button type="link" onClick={onOpenFeedback} className="dba-agent-tip-bubble__link" style={{ textDecoration: 'none' }}>
          {formatMessage({ id: 'dbh_nav_agent_tip_feedback' })}
        </Button>
      </div>
    </div>
  );

  return (
    <>
      <Bubble
        content={content}
        placement="bottom"
        overlayClassName="dba-agent-tip-bubble-overlay dba-nav-menu-overlay"
        arrowPointAtCenter
        dark
      >
        {children}
      </Bubble>

      {/* 反馈弹窗（声明式组件，非命令式副作用） */}
      <UnloadModal
        visible={feedbackVisible}
        close={onCloseFeedback}
      />
    </>
  );
};

export default AgentTipBubbleView;
